import { _ } from 'utils'
import { createEventRoute } from 'utils/routes'
import EmbeddedSpaceSetting from './EmbeddedSpaceSetting'

export default {
    embedded: createEventRoute({
        title: _('embedded_space.header', {}, false),
        breadcrumb: _('embedded_space.header', {}, false),
        hasSpaceBreadcrumb: true,
        path: '/embedded/:embeddedSlug',
        component: EmbeddedSpaceSetting,
        exact: true,
        context: 'embedded-space'
    }),
}
